import { Decimal } from 'decimal.js';

export function toMoney(decimal: Decimal) {
  return decimal.toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toNumber();
}
